module.exports = __webpack_public_path__ + "dist/fonts/roboto/Roboto-Bold-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./dist/fonts/roboto/Roboto-Bold-webfont.eot
// module id = 685
// module chunks = 0